import React, { useContext, useState, useEffect , useRef } from 'react';
import { Paper, TextField, MenuItem, Typography, CircularProgress } from '@mui/material';
import { Row, Col } from 'react-bootstrap';
import ApiService from '../../functions/apiService';
import './ticketing.css'
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from 'moment';
// import 'ckeditor5/ckeditor5.css';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AuthContext from '../../context/AuthContext';
import { useReactToPrint } from "react-to-print";

const TicketModal = ({ show, setShow, item, ticketApi }) => {
	const [loading, setLoading] = useState(false)
	const [ticketData, setTicketData] = useState(null);
	const [status, setStatus] = useState(4)
	const [isEdit, setIsEdit] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [description, setDescription] = useState('');	
	const { permission } = useContext(AuthContext);
	const printRef = useRef();

	const getTickets = (loader = true) => {
		const body = {
			'checklist_ticket_id': item?.id,
		}
		ApiService.post('/tickets/checklists/view-ticket', body)
			.then(({ data }) => {
				setTicketData(data)
				setStatus(data.tickteting_status.id)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const changeTicketStatus = (status) => {
		const body = {
			checklist_ticket_id: ticketData?.id,
			status: status,
		};

		ApiService.post('/tickets/checklists/update-status', body)
			.then((response) => {
				toast.success(response.message);
				getTickets()
				// ticketApi()
				// const transformedColumns = transformData(response.data);
				// setColumns(transformedColumns); 
			})
			.catch((error) => {
				toast.error(error?.data?.message);
			});
	};

	useEffect(() => {
		getTickets()
	}, [])

	useEffect(() => {
		if (ticketData?.description) {
			setDescription(ticketData.description);
		}
	}, [ticketData?.description]);

	// const download = () => {
	//     const link = document.createElement('a');
	//     link.href = ticketData?.image;
	//     link.download = "asdf.png"
	//     document.body.appendChild(link);
	//     link.click();
	//     document.body.removeChild(link);
	// }

	// const download = async () => {
	//     if (!ticketData?.image) {
	//         console.error("Image URL is missing");
	//         return;
	//     }

	//     try {
	//         const response = await fetch(ticketData.image, { mode: 'cors' });
	//         if (!response.ok) throw new Error('Fetch failed');

	//         const blob = await response.blob();
	//         const url = URL.createObjectURL(blob);

	//         const link = document.createElement('a');
	//         link.href = url;
	//         link.download = 'image.png';
	//         document.body.appendChild(link);
	//         link.click();
	//         document.body.removeChild(link);
	//         URL.revokeObjectURL(url);
	//     } catch (error) {
	//         console.error("Download failed:", error);
	//     }
	// }

	const updateDescription = () => {
		const body = {
			"ticket_id" : ticketData?.id,
			"description" : description
		};

		ApiService.post('/tickets/checklists/update-content', body)
			.then((response) => {
				toast.success(response.message);
				getTickets()
				setIsEditing(false)
			})
			.catch((error) => {
				toast.error(error?.data?.message);
			});
	};

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
		onBeforeGetContent: () =>
			new Promise((resolve) => {
				document.fonts.ready.then(() => resolve());
			}),
	});

	console.log(ticketData , "==========================")


	return (
		<Paper className='p-4'>

			{ticketData && (
				<>
					<div className='d-flex align-items-center gap-2'>
						<div className='green-circle' /> {`# ${ticketData.id}`}
					</div>

					<Row>
						<Col md={10}>
							<Typography fontWeight={700} fontSize={21} className="mb-2" style={{ marginTop: '2%' }}>{ticketData.title}</Typography>
						</Col>
						<Col md={1}>
							<ButtonTheme color='primary' style={{marginTop:'-5px'}} onClick={handlePrint}>
								Print
							</ButtonTheme>
						</Col>
						<Col md={1}>
							<img src='/images/close-icon.svg' onClick={() => {
								setShow(false)
								ticketApi()
							}} style={{ cursor: 'pointer', height: 25 }} />
						</Col>
					</Row>

					<Row>
						<Col md={7}>
							<Typography fontWeight={600} fontSize={17} className='mt-3'>
								Description
								{permission.includes('Emp_Auth') && permission.includes('Schedule_Auth') &&
									<>
										{isEditing ? 
											<VisibilityIcon
												sx={{ height: '16px', width: '16px', color: '#555555' , cursor:'pointer' , marginLeft:'5px' }} 
												onClick={() => setIsEditing(false)}
											/> : 
											<EditIcon 
												sx={{ height: '16px', width: '16px', color: '#555555' , cursor:'pointer' , marginLeft:'5px' }} 
												onClick={() => setIsEditing(true)}
											/>
										}
									</>
								}
							</Typography>
								{isEditing ? (
									<>
										<TextField
											className='mt-2'
											color='secondary'
											variant='outlined'
											placeholder='Add description...'
											multiline
											fullWidth
											value={description}
											onChange={(e) => setDescription(e.target.value)}
											inputProps={{ maxLength: 256 }}
											sx={{
												'& .MuiInputBase-root': {
													fontSize: '14px',
													backgroundColor: '#f9f9f9',
													borderRadius: '8px',
													height: '200px',
													alignItems: 'flex-start',
												},
												'& .MuiOutlinedInput-notchedOutline': {
													borderColor: '#ccc',
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
													borderColor: '#999',
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
													borderColor: '#3f51b5',
												},
											}}
										/>
										<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
													onClick={updateDescription}
											>
													Save
										</ButtonTheme>
									</>
								) : (
									<div className='desc-box mt-2'>
										<div dangerouslySetInnerHTML={{ __html: ticketData?.description }} />
									</div>
								)}
						</Col>

						<Col md={5}>
							<TextField
								select size='medium'
								placeholder='Status'
								className={`mt-0 w-45 ${ticketData?.tickteting_status?.id === 4 ? 'complete' : 'others'} `}
								color='secondary'
								variant="outlined"
								value={ticketData?.tickteting_status?.id}
								onChange={(e) => changeTicketStatus(e.target.value)}
								InputProps={{
									sx: {
										height: '33px',
										fontSize: '14px'
									}
								}}
								InputLabelProps={{
									sx: {
										fontSize: '14px'
									},
								}}
								sx={{
									"& .MuiSvgIcon-root": {
										color: ' #FFFFFF'
									},
									"& .MuiInputBase-root": {
										borderColor: ' #CCCCCC',
										color: ' #FFFFFF'

									},
									"& .MuiOutlinedInput-root": {
										borderColor: ' #CCCCCC',
										borderRadius: '8px'
									}
								}}
							>
								<MenuItem value={1}>To Do</MenuItem>
								<MenuItem value={2}>Progress</MenuItem>
								{/* <MenuItem value={3}>Review</MenuItem> */}
								<MenuItem value={4}>Completed</MenuItem>
								<MenuItem value={5}>Cancelled</MenuItem>
							</TextField>

							<div className="details-box mt-3">
								<div className="header">Details</div>
								<div className="content p-3">

									<div className='row'>
										<div className='detail-desc col-md-4'>Assigned By</div>
										<div className='col-md-auto p-0'>
											<div className='red-circle'>{`${ticketData?.assignee_employee_first_name?.charAt(0) || 'N'}${ticketData?.assignee_employee_last_name?.charAt(0) || 'A'}`.toUpperCase()}</div>
										</div>
										<div className='detail-desc col-md-7 px-1' style={{ color: '#000' }}>{`${ticketData?.assignee_employee_first_name || 'Unassigned'} ${ticketData?.assignee_employee_last_name || ''}`}</div>
									</div>

									<div className='row  mt-4'>
										<div className='detail-desc col-md-4'>Assigned To</div>
										<div className='col-md-auto p-0'>
											<div className='red-circle'>{`${ticketData?.employee_first_name?.charAt(0) || 'N'}${ticketData?.employee_last_name?.charAt(0) || 'A'}`.toUpperCase()}</div>
										</div>
										<div className='detail-desc col-md-7 px-1' style={{ color: '#000' }}>{`${ticketData?.employee_first_name || 'Unassigned'} ${ticketData?.employee_last_name || ''}`}</div>
									</div>

									{/* <div className='row mt-4'>
										<div className='detail-desc col-md-4'>Notified To</div>
										<div className='col-md-auto p-0'>
											<div className='red-circle'>{`${ticketData?.notify_employee_first_name?.charAt(0) || 'N'}${ticketData?.notify_employee_last_name?.charAt(0) || 'A'}`.toUpperCase()}</div>
										</div>
										<div className='detail-desc col-md-7 px-1' style={{ color: '#000' }}>{`${ticketData?.notify_employee_first_name || 'Unassigned'} ${ticketData?.notify_employee_last_name || ''}`}</div>
									</div> */}

									<div className='row mt-4'>
										<div className='detail-desc col-md-4'>Date</div>
										<div className='detail-desc col-md-7 px-1' style={{ color: '#000' }}>{moment(item?.date).format('MM/DD/YYYY')}</div>
									</div>

									<div className='row mt-4'>
										<div className='detail-desc col-md-4'>{ticketData?.ticket_type == 'location' || ticketData?.ticket_type == 'location_item' || ticketData?.checklist_item?.location ? 'Location' : 'Item'}</div>
										<div className='detail-desc col-md-7 px-1' style={{ color: '#000' }}>{ticketData?.checklist_item?.item_location?.item?.item_description || ticketData?.checklist_item?.location?.location_description || ticketData?.location_name || ticketData?.item_name || "Generalize Ticket"}</div>
									</div>
								</div>
							</div>
						</Col>
					</Row>

					<Typography fontWeight={600} fontSize={17} className='mt-3'>Attachments</Typography>
					{ticketData.image || ticketData.secondary_image ?
						<Row style={{ gap: 12 }} className='w-100 m-auto'>

							{ticketData.image &&
								<div className="image-box mt-3 col-auto p-0">
									<a target="blank" href={ticketData.image}>
										<div className="header" style={{ padding: 0, contain: 'content'}}>
											<div className='download-btn'>
												<img src='/images/cloud.png' width={20} height={20} />
											</div>
											<img src={ticketData?.image} width='100%' height='110px' style={{ borderRadius: '8px' }} />
										</div>
									</a>
								</div>
							}

							{ticketData.secondary_image &&
								<div className="image-box mt-3 col-auto p-0">
									<a target="blank" href={ticketData.secondary_image}>
										<div className="header" style={{ padding: 0, contain: 'content' }}>
											<div className='download-btn'>
												<img src='/images/cloud.png' width={20} height={20} />
											</div>
											<img src={ticketData?.secondary_image} width='100%' height='110px' style={{ borderRadius: '8px' }} />
										</div>
									</a>
								</div>
							}
						</Row>
						:
						<p>No Image Uploaded</p>
					}

					{/* <Row>
                        {isEdit == false ?
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                    onClick={() => { setIsEdit(true) }}
                                >
                                    Edit
                                </ButtonTheme>
                            </Col>
                            :
                            <>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                    // onClick={deleteCertificate}
                                    >
                                        Save
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4'
                                        onClick={() => { setShow(false) }}
                                    >
                                        Cancel
                                    </ButtonTheme>
                                </Col>
                            </>}
                    </Row> */}

				</>
			)}

			<div ref={printRef} className='print-header'
			>
				<div className='d-flex align-items-center justify-content-between'>
					Firehouse247
					<div className='text-center'>
						<h4>Checklist Data Report</h4>
					</div>
					<img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
				</div>

				<div className='mt-2'>
					<h5>Ticket Information</h5>
					<div className='font-fam p-3 mt-2' 
					style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
						<div>
							<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Title : <strong>{ticketData?.title}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Description : <strong>{ticketData?.description}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Assigned by : <strong>{ticketData?.assignee_employee_first_name + ticketData?.assignee_employee_last_name}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Assigned to : <strong>{ticketData?.employee_first_name + ticketData?.employee_last_name	}</strong></p>
						</div>
						<div>
							<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Status : <strong>{ticketData?.tickteting_status?.status}</strong></p>
						</div>
						<div style={{display:'flex' , gap:'10px' , paddingBottom:'10px'}}>
							{ticketData?.image &&
								<div style={{display:'flex' , flexDirection:'column'}}>
									Pri. Image <img src={ticketData?.image} width={'100px'} height={'100px'} style={{border:'1px solid #EAECF0' , borderRadius:'8px'}}/>
								</div>
							}

							{ticketData?.secondary_image &&
								<div style={{display:'flex' , flexDirection:'column'}}>
									Sec. Image <img src={ticketData?.secondary_image} width={'100px'} height={'100px'} style={{border:'1px solid #EAECF0' , borderRadius:'8px'}}/>
								</div>
							}
							
						</div>
					</div>
				</div>

				{(ticketData?.checklist_item || ticketData?.location || ticketData?.item_location) ?
					<div className='mt-3'>
						<h5>Location Information</h5>
						<div className='font-fam p-3 mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
							<div>
								<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Title : <strong>{ticketData?.checklist_item?.item_location?.item?.item_description || ticketData?.checklist_item?.location?.location_description || ticketData?.location_name || ticketData?.item_name}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingBottom:'10px'}}>Type : <strong>{ticketData?.ticket_type == 'location' || ticketData?.ticket_type == 'location_item' || ticketData?.checklist_item?.location ? 'Location' : 'Item'}</strong></p>
							</div>
						
							{ticketData?.checklist_item?.location?.location_entities?.length > 0 || ticketData?.checklist_item?.item_location?.item_entities?.length > 0 && (
								<h5>Entities</h5>
							)}
							
							{ticketData?.checklist_item?.location?.location_entities?.map((item)=>(
								<div style={{padding:'10px' , border:'1px solid #cccccc' , borderRadius:'12px'}}>
									<div>
										<p style={{marginBottom:'0px' , padding:'8px 10px'}}>Entity Title : <strong>{item?.entity?.name}</strong></p>
									</div>
									<div>
										<p style={{ marginBottom: "0px", padding: "0px 10px" }}>
											Attributes :{" "}
											<strong>
												{item?.attributes?.map((attr) => attr?.attribute?.name).join(", ")}
											</strong>
										</p>
									</div>
								</div>
							))}

							{ticketData?.checklist_item?.item_location?.item_entities?.map((item)=>(
								<div style={{padding:'10px' , border:'1px solid #cccccc' , borderRadius:'12px'}}>
									<div>
										<p style={{marginBottom:'0px' , padding:'8px 10px'}}>Entity Title : <strong>{item?.entity?.name}</strong></p>
									</div>
									<div>
										<p style={{ marginBottom: "0px", padding: "0px 10px" }}>
											Attributes :{" "}
											<strong>
												{item?.attributes?.map((attr) => attr?.attribute?.name).join(", ")}
											</strong>
										</p>
									</div>
								</div>
							))}
						</div>
					</div>
					:
					<h5 style={{marginTop:'20px' , display:'flex' , justifyContent:'center'}}>Generalize Ticket</h5>
				}				

			</div>

		</Paper>
	)
}

export default TicketModal